import { render, staticRenderFns } from "./WorkHourGraphWidget.vue?vue&type=template&id=4dc8dd9f&"
import script from "./WorkHourGraphWidget.vue?vue&type=script&lang=js&"
export * from "./WorkHourGraphWidget.vue?vue&type=script&lang=js&"
import style0 from "./WorkHourGraphWidget.vue?vue&type=style&index=0&id=4dc8dd9f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports